import gsap from 'gsap';

export const overlayReveal = (trigger) => {
    //const trigger = document.querySelector('.js-overlay-trigger');
    const close_element = document.querySelector('.close-overlay-desktop');

    close_element.classList.add("open");
    document.body.classList.add('overlay-open');
    
    let tl = gsap.timeline({
        onStart: () => {
            document.body.style.overflow = 'hidden';
            document.body.style.height = '100vh';
        }
    });
    tl.addLabel('start');
    //tl.to(close_element, {autoAlpha: 0, duration: 0.3, onComplete: () => {/*trigger.innerHTML = 'Close'*/}}, 'start');
    tl.to('.c-overlay-booking', {autoAlpha: 1, duration: 0.6}, 'start');

    
    tl.to('.mobile-nav-trigger', {autoAlpha: 0, duration: 0.1}, 'start');
    tl.to('.nav-item', {autoAlpha: 0, duration: 0.1}, 'start');
    tl.to('.c-hero_image_wrapper', {autoAlpha: 0, duration: 0.1}, 'start');
    tl.to(close_element, {autoAlpha: 1, duration: 0.3}, 'start+=0.6');
    tl.fromTo('.c-overlay__inner', {opacity: 0}, {duration: 0.5, delay: 0.15, opacity: 1});  
}

export const overlayHide = (trigger) => {
    //const trigger = document.querySelector('.js-overlay-trigger');
    const close_element = document.querySelector('.close-overlay-desktop');

    close_element.classList.remove("open");

    document.body.classList.remove('overlay-open');

    let tl = gsap.timeline({
        onComplete: () => {
            document.body.removeAttribute('style');
        }
    });
    tl.addLabel('start');
    tl.to(close_element, {autoAlpha: 0, duration: 0.3, onComplete: () => {/*trigger.innerHTML = 'Close'*/}}, 'start');
    tl.to('.nav-item', {autoAlpha: 1, duration: 0.3, delay:0.5}, 'start');
    tl.to('.mobile-nav-trigger', {autoAlpha: 1, duration: 0.3, delay:0.5}, 'start');
    
    tl.to('.c-hero_image_wrapper', {autoAlpha: 1, duration: 0.3, delay:0.5}, 'start');
    tl.to('.c-overlay-booking', {autoAlpha: 0, duration: 0.6}, 'start');
    tl.to(close_element, {autoAlpha: 0, duration: 0.3}, 'start+=0.6');
}









export const overlayRevealNews = () => {
    const trigger = document.querySelector('.js-overlay-trigger-newsletter');
    const close_element = document.querySelector('.close-overlay-desktop');

    close_element.classList.add("open");
    document.body.classList.add('overlay-open');
    
    let tl = gsap.timeline({
        onStart: () => {
            document.body.style.overflow = 'hidden';
            document.body.style.height = '100vh';
        }
    });
    tl.addLabel('start');
    //tl.to(close_element, {autoAlpha: 0, duration: 0.3, onComplete: () => {/*trigger.innerHTML = 'Close'*/}}, 'start');
    tl.to('.c-overlay-newsletter', {autoAlpha: 1, duration: 0.6}, 'start');
    tl.to('.nav-item', {autoAlpha: 0, duration: 0.1}, 'start');
    tl.to('.mobile-nav-trigger', {autoAlpha: 0, duration: 0.1}, 'start');
    

    tl.to('.c-hero_image_wrapper', {autoAlpha: 0, duration: 0.1}, 'start');
    tl.to(close_element, {autoAlpha: 1, duration: 0.3}, 'start+=0.6');
    tl.fromTo('.c-overlay__inner', {opacity: 0}, {duration: 0.5, delay: 0.15, opacity: 1});  
}

export const overlayHideNews = () => {
    const trigger = document.querySelector('.js-overlay-trigger-newsletter');
    const close_element = document.querySelector('.close-overlay-desktop');

    close_element.classList.remove("open");
    document.body.classList.remove('overlay-open');

    let tl = gsap.timeline({
        onComplete: () => {
            document.body.removeAttribute('style');
        }
    });
    tl.addLabel('start');
    tl.to(close_element, {autoAlpha: 0, duration: 0.3, onComplete: () => {/*trigger.innerHTML = 'Close'*/}}, 'start');
    tl.to('.nav-item', {autoAlpha: 1, duration: 0.3, delay:0.5}, 'start');
    tl.to('.mobile-nav-trigger', {autoAlpha: 1, duration: 0.3, delay:0.5}, 'start');

    tl.to('.c-hero_image_wrapper', {autoAlpha: 1, duration: 0.3, delay:0.5}, 'start');
    tl.to('.c-overlay-newsletter', {autoAlpha: 0, duration: 0.6}, 'start');
    tl.to(close_element, {autoAlpha: 0, duration: 0.3}, 'start+=0.6');
}









export const overlayRevealMobileNav = () => {
    const trigger = document.querySelector('.mobile-nav-trigger');
    const close_element = document.querySelector('.close-overlay-desktop');

    close_element.classList.add("open");
    document.body.classList.add('overlay-open');
    
    let tl = gsap.timeline({
        onStart: () => {
            document.body.style.overflow = 'hidden';
            document.body.style.height = '100vh';
        }
    });
    tl.addLabel('start');
    //tl.to(close_element, {autoAlpha: 0, duration: 0.3, onComplete: () => {/*trigger.innerHTML = 'Close'*/}}, 'start');
    tl.to('.c-overlay-mobile-nav', {autoAlpha: 1, duration: 0.6}, 'start');
    tl.to('.nav-item', {autoAlpha: 0, duration: 0.1}, 'start');
    tl.to('.mobile-nav-trigger', {autoAlpha: 0, duration: 0.1}, 'start');
    tl.to('.c-hero_image_wrapper', {autoAlpha: 0, duration: 0.1}, 'start');
    tl.to(close_element, {autoAlpha: 1, duration: 0.3}, 'start+=0.6');
    tl.fromTo('.c-overlay__inner', {opacity: 0}, {duration: 0.5, delay: 0.15, opacity: 1});  
}

export const overlayHideMobileNav = () => {
    const trigger = document.querySelector('.mobile-nav-trigger');
    const close_element = document.querySelector('.close-overlay-desktop');

    close_element.classList.remove("open");

    let tl = gsap.timeline({
        onComplete: () => {
            document.body.removeAttribute('style');
        }
    });
    tl.addLabel('start');
    tl.to(close_element, {autoAlpha: 0, duration: 0.3, onComplete: () => {/*trigger.innerHTML = 'Close'*/}}, 'start');
    tl.to('.nav-item', {autoAlpha: 1, duration: 0.3, delay:0.5}, 'start');
    tl.to('.mobile-nav-trigger', {autoAlpha: 1, duration: 0.3, delay:0.5}, 'start');
    tl.to('.c-hero_image_wrapper', {autoAlpha: 1, duration: 0.3, delay:0.5}, 'start');
    tl.to('.c-overlay-mobile-nav', {autoAlpha: 0, duration: 0.6}, 'start');
    tl.to(close_element, {autoAlpha: 0, duration: 0.3}, 'start+=0.6');
}